import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const s = ({
  title: l,
  titleId: o,
  ...i
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M709.958 425.709 468.465 659.586c-8.299 8.021-19.008 12.011-29.696 12.011-11.136 0-22.272-4.331-30.635-12.971l-95.061-98.112c-16.384-16.917-15.957-43.925.96-60.331 16.939-16.384 43.925-15.979 60.352.96l65.344 67.456 210.859-204.181c16.939-16.405 43.904-15.979 60.331.96 16.384 16.939 15.957 43.925-.96 60.331zM512.006 64.002c-247.424 0-448 200.576-448 448s200.576 448 448 448c247.403 0 448-200.576 448-448s-200.597-448-448-448",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = r(s);
export {
  m as default
};
